"use strict";
// tslint:disable
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// JS
var lodash_1 = __importDefault(require("lodash"));
window._ = lodash_1.default;
require("lodash-aliases/dist/lodash-aliases.js");
var jquery_1 = __importDefault(require("jquery"));
window.$ = jquery_1.default;
window.jQuery = jquery_1.default;
require("jquery.pointer-events-polyfill/dist/jquery.pointer-events-polyfill.min.js");
// moment-timezone also imports moment.
// @ts-ignore
var moment_timezone_js_1 = __importDefault(require("moment-timezone/moment-timezone.js"));
window.moment = moment_timezone_js_1.default;
require("moment/min/locales.js");
require("angular/angular.js");
require("angular-strap/dist/angular-strap.js");
require("angular-strap/dist/angular-strap.tpl.js");
require("angular-sanitize/angular-sanitize.js");
require("angular-route/angular-route.js");
require("ripsaw-client/dist/ripsaw.js");
require("qstrap/dist/js/qstrap.js");
var quill_1 = __importDefault(require("quill"));
window.Quill = quill_1.default;
require("global-wrapper-fallback/fallback.js");
require("angular-translate/dist/angular-translate.min.js");
require("angular-translate-loader-static-files/angular-translate-loader-static-files.min.js");
require("angular-dynamic-locale/dist/tmhDynamicLocale.min.js");
// @ts-ignore
var d3_min_js_1 = __importDefault(require("@qualtrics/dq/dist/d3.min.js"));
window.d3 = d3_min_js_1.default;
// @ts-ignore
var dq = __importStar(require("@qualtrics/dq/dist/dq.js"));
window.dq = dq;
// Attaches itself to the window.
require("webcomponentsjs/micro.js");
require("rum/dist/rum.ng.js");
require("fieldset-filters/dist/js/filters-client.js");
require("@qualtrics/cp-folder-selector/folder-selector.js");
require("tractive-angular/tractive-angular.js");
// @ts-ignore
var react_1 = __importDefault(require("react"));
window.React = react_1.default;
// @ts-ignore
var react_dom_1 = __importDefault(require("react-dom"));
window.ReactDOM = react_dom_1.default;
var dompurify_1 = __importDefault(require("dompurify"));
window.DOMPurify = dompurify_1.default;
// Redux must be imported using a require
var redux = require('redux');
window.Redux = redux;
var reduxThunk = require('redux-thunk');
window.ReduxThunk = reduxThunk;
// CSS
require("qstrap/dist/css/qstrap.css");
require("@qualtrics/dq/dist/dq.css");
require("quill/dist/quill.snow.css");
require("fieldset-filters/dist/css/filters-client.css");
require("@qualtrics/cp-folder-selector/folder-selector.css");
